<template>
  <ol class="correctWrongList">
    <li v-for="(question , index) in questionCorrectWrongList" :key="index" :class="{'active': isActive(index)}">
      <span class="block">
        <span :class="{'iconCorrect': question.progress === 1 && question.result === true,
                       'iconWrong':question.progress === 1 && question.result === false,
                       'iconSkip': question.progress === 1 && question.result === null}"
              v-text="getText(question)"></span>
      </span>
    </li>
  </ol>
</template>

<script setup lang="ts">
  interface ICorrectWrongList{
      result: boolean | null;
      progress: number;
  }
  const props = withDefaults(
    defineProps<{
      position?: number;
      questionCorrectWrongList: ICorrectWrongList[] //FIXME:progressとresultを持つInterfaceにするか検討する
    }>(),
    {
      position: 0,
    }
  );

  function isActive(index){
    return index === props.position
  }

  //FIXME:progress 0~2は定数に変更する
  function getText(question){
    if(question.progress === 0){
      return "?"
    }else if(question.progress === 2){
      return ""
    }
  }
</script>
